export enum SurveyTaskProgressStates {
    Open = 'open',
    InProgress = 'inProgress',
    Completed = 'completed',
    NotApplicable = 'notApplicable',
}
